import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectorRef
} from "@angular/core";
import { VehicleBrandService } from "../../../core/services/vehicle-brand.service";
import { VehicleBrandDTO } from "../../models/vehicle-brand-dto";
import { take } from "rxjs/operators";
import { UntypedFormControl, Validators } from "@angular/forms";
import { HelperService } from "../../../core/services/helper.service";
import { GenericComponent } from "../../components/generic.component";
import { Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";

@Component({
  selector: "app-smartfleet-vehicle-brand-auto-complete",
  templateUrl: "./vehicle-brand-auto-complete.component.html",
  styleUrls: ["./vehicle-brand-auto-complete.component.scss"],
  standalone: false
})
export class VehicleBrandAutoCompleteComponent
  extends GenericComponent
  implements OnInit, OnChanges, OnDestroy
{
  brand = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.brand
  });
  allBrands: VehicleBrandDTO[] = [];
  brands: VehicleBrandDTO[] = [];
  isRequired = false;
  private filterSub: Subscription;

  @Input() style: string;
  @Input() page: string;
  @Input() currentBrandId: number;
  @Input() resetForm: boolean;
  @Output() vehicleBrandDTO: any = new EventEmitter<VehicleBrandDTO>();

  @Input() set required(value: boolean) {
    if (value) {
      this.isRequired = value;
      this.searchForm.controls.name.setValidators([Validators.required]);
      this.searchForm.controls.name.updateValueAndValidity();
    }
  }

  constructor(
    private vehicleBrandService: VehicleBrandService,
    private helperService: HelperService,
    private cdr: ChangeDetectorRef,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.page && this.page !== "") {
      let key: string;
      switch (this.page) {
        case "vehicle-model":
          key = "vm-vehicleBrand";
          break;
        case "vehicle":
          key = "vc-vehicleBrand";
          break;
        case "my-fleet":
          key = "my-fleet-vehicleBrand";
          break;
        case "maintenance-plan":
          key = "mp-vehicleBrand";
          break;
        default:
          key = null;
          break;
      }
      if (key) {
        const ls = localStorage.getItem(key);
        if (ls) {
          const vehicleBrand = JSON.parse(ls);
          this.searchForm.controls.name.setValue(vehicleBrand["name"]);
        }
      }
    } else {
      this.clean();
    }

    this.listAllBrands();
    this.filterBrands();
  }

  listAllBrands(): void {
    this.vehicleBrandService
      .listAll()
      .pipe(take(1))
      .subscribe(
        (allBrands) => {
          this.allBrands =
            this.helperService.sortArray(allBrands, "name") || [];
          this.brands = [...this.allBrands];

          if (this.currentBrandId) {
            const brand = this.brands.find(
              (b) => Number(b.id) === Number(this.currentBrandId)
            );
            if (brand) {
              this.searchForm.patchValue({ name: brand.name });
            }
          }

          this.cdr.markForCheck();
          console.debug("vehicle brands loaded", this.allBrands);
        },
        (err) => {
          console.error("Erro ao carregar vehicle brands", err);
        }
      );

    if (this.resetForm === true) {
      this.resetForm = !this.resetForm;
      this.searchForm.patchValue({
        name: ""
      });
    }
  }

  filterBrands(): void {
    if (this.filterSub && !this.filterSub.closed) {
      return;
    }

    this.filterSub = this.brand.valueChanges
      .pipe(debounceTime(200), distinctUntilChanged())
      .subscribe((search) => {
        console.debug("autocomplete search:", search);
        if (search && typeof search === "string") {
          const normalizedSearch = this.helperService.normalizeWord(search);
          const filtered = this.allBrands.filter(
            (item) =>
              this.helperService
                .normalizeWord(item.name)
                .indexOf(normalizedSearch) > -1
          );
          this.brands = this.helperService.sortArray(filtered, "name");
        } else {
          this.brands = [...this.allBrands];
        }
        this.cdr.markForCheck();
      });
  }

  onOptionSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedName = event.option.value;
    const brand =
      this.allBrands.find((b) => b.name === selectedName) ||
      this.brands.find((b) => b.name === selectedName);
    if (brand) {
      this.vehicleBrandDTO.emit(brand);
    }
  }

  setBrand(event: any, brandDTO: VehicleBrandDTO): void {
    if (event && event.isUserInput === true) {
      this.vehicleBrandDTO.emit(brandDTO);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentBrandId && !changes.currentBrandId.firstChange) {
      this.listAllBrands();
    } else if (
      changes.resetForm &&
      !changes.resetForm.firstChange &&
      this.resetForm
    ) {
      this.searchForm.patchValue({ name: "" });
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.brands = [...this.allBrands];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.brands = [...this.allBrands];
  }

  ngOnDestroy(): void {
    if (this.filterSub) {
      this.filterSub.unsubscribe();
    }
  }
}
